import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import DestinationActions from '../../Redux/DestinationRedux'

class ViewMapping extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
      showModal: null,
      destination: ''
    }
  }

  _toggleModal = (modalId = null, destination = '') => {
    this.setState({ showModal: modalId, destination })
  }

  _submit = (event) => {
    event.preventDefault()
    const content = {
      country_id: null,
    }

    this.props.submit(this.state.destination.id, content)
    this._toggleModal()
  }

  render() {
    const { detail } = this.props
    return (
      <div className="section" style={{ width: '50vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">Destination List in <em>{ detail.name }</em></h4>
        </header>
        <div className="section table-responsive">
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Destination</th>
                <th className="text-center">Delete Mapping</th>
              </tr>
            </thead>
            <tbody>
              {detail.destinations && detail.destinations.map((dest, i) => (
                <tr key={i}>
                  <td>{ dest.name || '-' }</td>
                  <td className="text-center">
                    <button className="btn btn-danger" onClick={() => this._toggleModal('delete', dest)}>
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
          <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '40vw' }}>
            <div className="title-block">
              <h4 className="title mr-auto">Delete Mapping ?</h4>
            </div>
            <div className="section">
              <div className="text-center mb-2">
                <h5 className="title">{ this.state.destination.name }</h5>
              </div>
              <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this._toggleModal()}>Close</button>
                <button type="submit" className="btn btn-lg btn-danger">Delete</button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  submit: (id, content) => dispatch(DestinationActions.destinationUpdateRequest({id, content})),
})

export default connect(stateToProps, dispatchToProps)(ViewMapping)



// WEBPACK FOOTER //
// ./src/Containers/Destination/ViewMapping.js